<a
  [routerLink]="url()"
  [routerLinkActive]="[
    'bg-(--content-selection-secondary)',
    'border-l-(--content-selection-primary)',
    'text-(--content-selection-tertiary)',
  ]"
  [routerLinkActiveOptions]="{
    paths: paths(),
    queryParams: 'ignored',
    fragment: 'ignored',
    matrixParams: 'ignored',
  }"
  (click)="onItemClick()"
  class="flex h-12 items-center rounded-r-sm border-l-2 border-transparent p-3 pl-3.5"
  data-testid="a-sidebar-item"
>
  @if (!minimised()) {
    <span class="w-6" data-testid="span-toggle"></span>
  }
  <span [class]="icon()" [attr.title]="label()" [attr.aria-label]="label()" data-testid="span-icon"></span>
  @if (!minimised()) {
    <span class="ml-2 text-nowrap" data-testid="span-label">{{ label() }}</span>
  }
</a>
